<template>
  <v-layout justify-center>
    <v-dialog v-model="activeNew" width="500">
      <v-card>
        <v-card-title>
          <span class="headline">Recarga</span>
        </v-card-title>
        <div v-if="isLoad" class="text-center">
          <v-progress-circular
            indeterminate
            v-bind:color="color"
          ></v-progress-circular>
        </div>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-layout row wrap>
                <v-flex v-show="showError" xs12 sm6 md4>
                  <div class="red text-center">
                    <v-icon color="white">error</v-icon>
                    <span class="white--text"
                      ><p><strong>Código: </strong>{{ errors.status }}</p></span
                    >
                    <span class="white--text"
                      ><p>
                        <strong>Mensagem: </strong>{{ errors.message }}
                      </p></span
                    >
                    <span class="white--text"
                      ><p>
                        <strong>Detalhe: </strong> {{ errors.detail }}
                      </p></span
                    >
                  </div>
                </v-flex>
                <v-flex v-show="showLoad" xs12 sm6 md4>
                  <div class="blue text-center">
                    <v-icon color="white">more_time</v-icon>
                    <span class="white--text"
                      ><p><strong>Carregando...</strong></p></span
                    >
                  </div>
                </v-flex>
                <v-flex v-show="showSuccess" xs12 sm6 md4>
                  <div class="green text-center">
                    <v-icon color="white">done</v-icon>
                    <span class="white--text"
                      ><p>
                        <strong>Recarga Feita com sucesso</strong> Id:
                        {{ recharge.id }}
                      </p></span
                    >
                    <span class="white--text"
                      ><p><strong>Detalhe: </strong> detail</p></span
                    >
                  </div>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="area_code"
                    :rules="areaRules"
                    label="Código de área"
                    hint="11"
                    minLength="2"
                    maxLength="2"
                    :counter="2"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                    v-model="provider"
                    :items="providers"
                    label="Selecione a Operadora*"
                    item-text="provider"
                    item-value="provider"
                    @change="setProducts"
                    return-object
                    :rules="providerRules"
                    required
                  >
                  </v-select>
                  <!--<v-text> Campo Operadora: {{ provider }}</v-text>-->
                </v-flex>
                <v-flex v-show="showSigner" xs12 sm6 md4>
                  <v-text-field
                    v-model="signerCode"
                    label="CPF Assinante"
                    hint="11"
                    minLength="11"
                    maxLength="11"
                    :counter="11"
                  ></v-text-field>
                </v-flex>
                <v-flex v-show="showNumber" xs12 sm6 md4>
                  <v-text-field
                    v-model="number"
                    :rules="contactRules"
                    label="Número do celular"
                    hint="999999999"
                    minLength="8"
                    maxLength="9"
                    :counter="9"
                  ></v-text-field>
                </v-flex>
                <v-flex v-show="showAmount" xs12 sm6>
                  <v-select
                    v-model="product"
                    :items="products"
                    label="Selecione o valor*"
                    item-text="name"
                    item-value="product_id"
                    return-object
                    :rules="amountRules"
                    required
                  >
                  </v-select>
                  <!--<v-text> Campo Valor: {{ product }}</v-text>-->
                </v-flex>
                <v-flex v-show="showAmountVari" xs12 sm6 md4>
                  <v-text-field
                    v-model="amountVari"
                    label="Valor variado R$"
                    v-money="money"
                    hint="10"
                    minLength="1"
                  ></v-text-field>
                  <p>
                    OBS: Valor deve estar entre R$ {{ amountVariMin }} e R$
                    {{ amountVariMax }}
                  </p>
                </v-flex>
              </v-layout>
            </v-container>
            <small>*Campos indicados são requeridos</small>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-bind:color="color" text @click="desableNew">Fechar</v-btn>
          <v-btn
            v-show="showSubmit"
            v-bind:color="color"
            text
            @click="sendRecharge"
            >Enviar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "@/services/event-bus";
import moment from "moment";
import { VMoney } from "v-money";
import { mask } from "vue-the-mask";

export default {
  data() {
    return {
      dialog: false,
      valid: true,
      isLoading: false,
      area_code: null,
      product: { amount: 0, product_id: null, provider: null },
      number: null,
      provider: { provider: null, product_id: null, amount: 0 },
      signerCode: "",
      showSigner: false,
      amountVari: 0,
      amountVariMin: 0,
      amountVariMax: 0,
      showAmountVari: false,
      contactRules: [
        (v) => !!v || "Contato é requirido",
        (v) => (v && v.length == 9) || "Número inválido.",
        (v) => /^[0-9]+$/.test(v) || "Somente números",
      ],
      areaRules: [
        (v) => !!v || "Código de área é requirido",
        (v) => (v && v.length == 2) || "Código inválido.",
        (v) => /^[0-9]+$/.test(v) || "Somente números",
      ],
      amountRules: [(v) => !!v || "Valor é requirido"],
      providerRules: [(v) => !!v || "Operadora é requirido"],
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false,
      },
    };
  },
  directives: { money: VMoney, mask },
  created() {
    this.isLoading = this.isLoad;
  },
  computed: {
    ...mapGetters({
      activeNew: "recharges/activeNew",
      isLoad: "recharges/isLoad",
      providers: "recharges/providers",
      products: "recharges/products",
      showAmount: "recharges/showAmount",
      showSubmit: "recharges/showSubmit",
      showNumber: "recharges/showNumber",
      showLoad: "recharges/showLoad",
      showError: "recharges/showError",
      showSuccess: "recharges/showSuccess",
      recharge: "recharges/recharge",
      errors: "recharges/errors",
      color: "account/color",
    }),
    pages() {
      return 0;
    },
  },
  methods: {
    desableNew() {
      this.$store.dispatch("recharges/activeNew", false);
      this.$store.dispatch("recharges/showSubmit", false);
      this.$store.dispatch("recharges/showNumber", false);
      this.$store.dispatch("recharges/showAmount", false);
      this.$store.dispatch("recharges/showError", false);
      this.$store.dispatch("recharges/showSuccess", false);
      this.$store.dispatch("recharges/showLoad", false);
      this.amount = null;
      this.number = null;
      this.area_code = null;
      this.provider = null;
    },
    setProducts() {
      this.$store.dispatch("recharges/isLoad", true);
      this.$store.dispatch("recharges/showLoad", true);
      this.product_send = {
        area: this.area_code,
        provider: this.provider.provider,
        kind: this.provider.kind,
        signer_code: this.signer_code,
      };
      this.$store.dispatch("recharges/products", this.product_send);
      this.$store.dispatch("recharges/showLoad", false);
    },
    sendRecharge() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("recharges/isLoad", true);
        this.$store.dispatch("recharges/showLoad", true);
        this.$store.dispatch("recharges/showSubmit", false);
        this.recharge_send = {
          product_id: this.product.product_id,
          provider: this.provider.provider,
          kind: this.provider.kind,
          area_code: this.area_code,
          cell_phone_number: this.number,
          amount: this.product.amount,
          signer_code: this.signerCode,
        };
        if (
          this.product.name.includes("VARI") ||
          this.product.name.includes("-")
        ) {
          this.recharge_send.amount = parseFloat(
            this.amountVari.replace(/[^\d]+/g, "")
          );
        }
        this.$store.dispatch("recharges/recharge", this.recharge_send);
        this.$store.dispatch("recharges/showLoad", false);
      }
    },
  },
  watch: {
    isLoad(value) {
      this.isLoading = this.isLoad;
    },
    product(value) {
      if (value.name.includes("VARI") || this.product.name.includes("-")) {
        this.showAmountVari = true;
        this.amountVariMin = value.minimum_amount / 100;
        this.amountVariMax = value.maximum_amount / 100;
      }
    },
    provider(value) {
      if (value.kind.includes("tv")) {
        this.showSigner = true;
      }
    },
    showLoad(value) {},
    recharge(value) {
      this.desableNew();
      this.$router.push({ name: "recharges-show", params: { id: value.id } });
    },
  },
};
</script>
